<template>
  <div class="flex gap-2 relative">
    <div v-if="disabled" class="z-10 w-full h-full absolute"></div>
    <button
      class="h-24 w-24 rounded border-2 flex items-center justify-center text-red-600 hover:bg-red-200"
      :class="{ 'border-red-600 bg-red-200': score === 1, 'border-gray-200': score !== 1 }"
      @click="$emit('set-score', 1)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90M82 108a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10m-.81 65a6 6 0 0 1-10.38 6c-7.84-13.54-20.2-21-34.81-21s-27 7.46-34.81 21a6 6 0 0 1-5.2 3a5.9 5.9 0 0 1-3-.81a6 6 0 0 1-2.18-8.19c9.92-17.16 26.39-27 45.19-27s35.27 9.84 45.19 27"
        />
      </svg>
    </button>
    <button
      class="h-24 w-24 rounded border-2 flex items-center justify-center text-red-300 hover:bg-red-100"
      :class="{ 'border-red-300 bg-red-100': score === 2, 'border-gray-200': score !== 2 }"
      @click="$emit('set-score', 2)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90m46-58a6 6 0 0 1-6 6H88a6 6 0 0 1 0-12h80a6 6 0 0 1 6 6m-92-52a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10"
        />
      </svg>
    </button>
    <button
      class="h-24 w-24 rounded border-2 flex items-center justify-center text-yellow-400 hover:bg-yellow-100"
      :class="{ 'border-yellow-400 bg-yellow-100': score === 3, 'border-gray-200': score !== 3 }"
      @click="$emit('set-score', 3)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90m46-58a6 6 0 0 1-6 6H88a6 6 0 0 1 0-12h80a6 6 0 0 1 6 6m-92-52a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10"
        />
      </svg>
    </button>
    <button
      class="h-24 w-24 rounded border-2 flex items-center justify-center text-green-300 hover:bg-green-100"
      :class="{ 'border-green-300 bg-green-100': score === 4, 'border-gray-200': score !== 4 }"
      @click="$emit('set-score', 4)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90m46-58a6 6 0 0 1-6 6H88a6 6 0 0 1 0-12h80a6 6 0 0 1 6 6m-92-52a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10"
        />
      </svg>
    </button>
    <button
      class="h-24 w-24 rounded border-2 flex items-center justify-center text-green-600 hover:bg-green-200"
      :class="{ 'border-green-600 bg-green-200': score === 5, 'border-gray-200': score !== 5 }"
      @click="$emit('set-score', 5)"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
        <path
          fill="currentColor"
          d="M173.19 155c-9.92 17.16-26.39 27-45.19 27s-35.27-9.84-45.19-27a6 6 0 0 1 10.38-6c7.84 13.54 20.2 21 34.81 21s27-7.46 34.81-21a6 6 0 1 1 10.38 6M230 128A102 102 0 1 1 128 26a102.12 102.12 0 0 1 102 102m-12 0a90 90 0 1 0-90 90a90.1 90.1 0 0 0 90-90M92 118a10 10 0 1 0-10-10a10 10 0 0 0 10 10m72-20a10 10 0 1 0 10 10a10 10 0 0 0-10-10"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
